import React, { useState, useEffect } from "react";
import { Modal, Table, Card, Typography, Space } from "antd";
import { getDirectusClient } from "../../../lib/directus";
import { readItems } from "@directus/sdk";
import moment from "moment";

const { Text } = Typography;

const VendorDetails = ({ visible, vendor, onClose, cajasIds }) => {
  const [loading, setLoading] = useState(false);
  const [facturas, setFacturas] = useState([]);
console.log('cajasIds', cajasIds);

  const fetchFacturas = async () => {
    if (!vendor?.id) return;

    setLoading(true);
    try {
      const directus = await getDirectusClient();
      const response = await directus.request(
        readItems("facturas", {
          fields: [
            "id",
            "caja.id",
            "caja.vendedor.id",
            "caja.vendedor.first_name",
            "productos.cantidad",
            "productos.precio_unitario",
            "productos.producto.grupo.impuesto",
            "estado",
            "tipo",
            "consecutivo",
            "date_created",
            "productos.cantidad",
            "productos.producto.nombre",
            "cliente.first_name",
            "cliente.last_name",
          ],
          filter: {
            caja: { _in: cajasIds },
          },
        })
      );

      setFacturas(response);
    } catch (error) {
      console.error("Error fetching facturas:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (visible && vendor) {
      fetchFacturas();
    }
  }, [visible, vendor]);

  const columns = [
    {
      title: "Consecutivo",
      dataIndex: "consecutivo",
      key: "consecutivo",
    },
    {
      title: "Cliente",
      key: "cliente",
      render: (_, record) =>
        `${record.cliente?.first_name || ""} ${
          record.cliente?.last_name || ""
        }`,
    },
    {
      title: "Fecha",
      dataIndex: "date_created",
      key: "date_created",
      render: (date) => moment(date).format("DD/MM/YYYY"),
    },
    {
      title: "Total Seriales",
      key: "total_seriales",
      render: (_, record) =>
        record.productos?.reduce(
          (sum, prod) => sum + (prod.cantidad || 0),
          0
        ) || 0,
    },
    {
      title: "Total",
      key: "total",
      render: (_, record) => {
        const total =
          record.productos?.reduce((sum, prod) => {
            const subtotal = (prod.cantidad || 0) * (prod.precio_unitario || 0);
            return sum + subtotal;
          }, 0) || 0;
        return `$${total.toLocaleString()}`;
      },
    },
  ];

  return (
    <Modal
      title={`Facturas de ${vendor?.first_name || ""}`}
      open={visible}
      onCancel={onClose}
      width={1200}
      footer={null}
    >
      <Table
        columns={columns}
        dataSource={facturas}
        loading={loading}
        rowKey="id"
        pagination={{ pageSize: 10 }}
        summary={(pageData) => (
          <Table.Summary.Row>
            <Table.Summary.Cell index={0} colSpan={3}>
              <Text strong>Totales:</Text>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={3}>
              <Text strong>
                {pageData.reduce(
                  (sum, record) =>
                    sum +
                    (record.productos?.reduce(
                      (s, p) => s + (p.cantidad || 0),
                      0
                    ) || 0),
                  0
                )}
              </Text>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={4}>
              <Text strong>
                $
                {pageData
                  .reduce(
                    (sum, record) =>
                      sum +
                      (record.productos?.reduce(
                        (s, p) =>
                          s + (p.cantidad || 0) * (p.precio_unitario || 0),
                        0
                      ) || 0),
                    0
                  )
                  .toLocaleString()}
              </Text>
            </Table.Summary.Cell>
          </Table.Summary.Row>
        )}
      />
    </Modal>
  );
};

export default VendorDetails;
